import React from 'react'
import { ScrollView, Text, View } from 'react-native'
import HeaderWithBack from '../../components/Header/headerWithBack';
import { useTranslation } from 'react-i18next';
import { useCssStyle } from '../../customHook/getCssStyle';
import { useDispatch, useSelector } from 'react-redux';
import { ImageComp } from '../../components/Image/Image';
import { getCleanUrl } from '../../utils/Helper';
import CustomPressable from '../../components/customPressable/customPressable';

const ReservationsSuccess = (props) => {
    const { selectedEvent, handleNext, handleGoBack } = props;

    const { t } = useTranslation();
    const getStyles = useCssStyle();
    const dispatch = useDispatch();

    const { currentWidget } = useSelector(state => state.deviceConfigSlice);

    const renderHeader = () => {
        return <View style={getStyles(['widgetmainContainerHeaderContainer', 'reservationsHeaderContainer'])}>
        {
            currentWidget?.widgetHeaderImageUrl &&
            <ImageComp source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'reservationsHeaderImg'])} />
        }
        <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'reservationsHeaderTitleContainer'])}>
            <Text style={getStyles(['widgetmainContainerHeaderTitle', 'reservationsHeaderTitle'])}>{t('events.headingSuccess')}</Text>
            <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'reservationsHeaderSubTitle'])}>{t('events.sub_headingSuccess')}</Text>
        </View>
        </View>
    }

    return (
        <View style={getStyles(['widgetRootContainer', 'reservationsRootContainer'])}>
            <HeaderWithBack handleCustomBackPress={handleGoBack} />
                                    
            <ScrollView
                automaticallyAdjustKeyboardInsets={true} 
                contentContainerStyle={getStyles(['widgetmainContainer', 'reservationsMainContainer'])} 
                showsVerticalScrollIndicator={false}
            >
                {renderHeader()}

                <View style={getStyles(['widgetmainContainerChildContainer', 'reservationsMainContainerChildContainer'])}>
                    <Text style={getStyles(["reservationsMainContainerSuccessText"])}>{t("events.success_page_body").replace("#EVENT_NAME", selectedEvent.eventName)}</Text>
                </View>
                
            </ScrollView>

            <View id='reservationsNextButtonContainer' style={getStyles(['reservationsNextButtonContainer'])}>
                <CustomPressable style={getStyles(["primaryBtn"])} onPress={()=> handleNext()} id="primaryBtn">
                    <Text style={getStyles(["primaryBtnTxt"])} id='primaryBtnTxt'>
                        {t("events.okay")}
                    </Text>
                </CustomPressable>
            </View>
        </View>
    )
}

export default ReservationsSuccess
